import React from 'react';
import { motion } from 'framer-motion';
import { ChefHatIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-brand-pink bg-brand-cream" data-id="element-98" data-mp="4mi319qcrmdy">
      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-99" data-mp="129h1nq0lv4eh">
        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="inline-flex items-center gap-1.5 rounded-full bg-brand-pink px-3 py-1 font-display text-[0.62rem] font-bold uppercase tracking-[0.12em] text-white" data-id="element-100" data-mp="127eeddqu7pdg">
          <ChefHatIcon size={12} data-id="element-101" data-mp="3d1a4za4glt8j" />
          Método de aprendizaje paso a paso
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 font-display text-[1.4rem] font-black uppercase leading-[1.08] text-brand-choco sm:text-3xl" data-id="element-102" data-mp="382p9fo05jxqf">
          El sistema completo para aprender{' '}
          <span className="text-brand-pink" data-id="element-103" data-mp="399tc6xt32ga8">pastelería desde cero</span> y
          comenzar a emprender
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-brand-choco/85 sm:text-[0.92rem]" data-id="element-104" data-mp="3eb8zkwiqgyvs">
          Aprendé a preparar tortas, brownies, alfajores, budines y productos de
          pastelería para vender, sin perderte entre cientos de recetas, videos y
          tutoriales que nunca te explican cómo empezar un emprendimiento.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.12
      }} className="mt-2 inline-block rounded-md border-2 border-brand-gold bg-brand-choco px-3 py-1.5 font-display text-[0.65rem] font-black uppercase leading-tight tracking-wide text-white sm:text-xs" data-id="element-105" data-mp="2ll0i76w0uii9">
          {PRODUCT_NAME} · <span className="text-brand-gold" data-id="element-106" data-mp="degfkj0scgsl">6 Tomos + 5 Bonos</span>
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.16
      }} className="mt-2 block overflow-hidden rounded-xl border-4 border-brand-pink bg-white" data-id="element-107" data-mp="1b15lh3ylzdjq">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-108" data-mp="x0cq6h0hgefk" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.2
      }} className="mt-3" data-id="element-109" data-mp="3hqaj2p91pbl1">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-110" data-mp="21bxx31tbem9r">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-brand-choco/85" data-id="element-111" data-mp="268g3e64amso7">
            <span className="flex items-center gap-1" data-id="element-112" data-mp="2fzss4ousp2q0">
              <ZapIcon size={12} className="text-brand-pink" data-id="element-113" data-mp="2fzaov89pto8l" />
              Acceso Digital Inmediato
            </span>
            <span className="text-brand-choco/40" data-id="element-114" data-mp="2l102mvobog0d">•</span>
            <span className="flex items-center gap-1" data-id="element-115" data-mp="2p1jylvx5tdkx">
              <ShieldCheckIcon size={12} className="text-brand-gold" data-id="element-116" data-mp="2oynwrwi6y4r7" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}